import { useState, useEffect } from "react";
import { toast } from "react-toastify";

const AcceptingModule = ({
  modal,
  setModal,
  clientData,
  curationData,
  manuscriptStatus,
  freezeStatus,
  addComment,
}) => {
  const [isAbstractOpen, setIsAbstractOpen] = useState(false);
  const [comment, setcomment] = useState("");
  const [updatedCurationData, setupdatedCurationData] = useState(null);
  useEffect(() => {
    setcomment(curationData.comment);
    setupdatedCurationData(curationData);
  }, [curationData]);

  const handleSaveComment = () => {
    if (comment !== null && comment.trim() !== "") {
      addComment(curationData._id, comment);
      setupdatedCurationData((prev) => ({ ...prev, comment: comment }));
      // toast.success("Comment saved");
    } else {
      if (window.confirm("Are you sure you want to save an empty comment?")) {
        addComment(curationData._id, "");
        setupdatedCurationData((prev) => ({ ...prev, comment: "" }));
        toast.info("Empty comment saved");
      } else {
        toast.error("Saving cancelled. Empty comment not saved.");
      }
    }
  };

  const abstractHandler = () => {
    setIsAbstractOpen(!isAbstractOpen);
  };

  const highlightAllContinuousMatches = (text, match) => {
    console.log(text, match);
    if (!match) return text; // If no match, return the original text

    // Split both the text and match_title into arrays of words
    const textWords = text.split(/\s+/);
    const matchWords = match.split(/\s+/);

    const matches = [];

    // Find all continuous matches between the two arrays of words
    for (let i = 0; i < textWords.length; i++) {
      for (let j = 0; j < matchWords.length; j++) {
        let k = 0;
        // Check for a match
        while (
          textWords[i + k] === matchWords[j + k] &&
          i + k < textWords.length &&
          j + k < matchWords.length
        ) {
          k++;
        }
        if (k > 1) {
          // Only add matches of 2 or more words (to ensure it’s a real match)
          matches.push(textWords.slice(i, i + k).join(" "));
        }
      }
    }

    // Create a regex to highlight all the matches
    const regex = new RegExp(`(${matches.join("|")})`, "gi");

    // Replace all matches in the text with the highlighted version
    return text.split(regex).map((part, index) =>
      matches.some((match) => part.toLowerCase() === match.toLowerCase()) ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const highlightAuthorMatches = (text, match) => {
    if (!match) return text; // If no match, return the original text

    text = text?.toString() || "";
    match = match?.toString() || "";

    // let normalizedText = normalizeDashesAndSpaces(text?.toString() || "");
    // let normalizedMatch = normalizeDashesAndSpaces(match?.toString() || "");

    // Split into individual words
    const textWords = text.split(/[\s-–—‐]+/);
    const matchWords = match.split(/[\s-–—‐]+/);
    // const textWords = normalizedText.split(/[\s-]+/); // Split by space or hyphen
    // const matchWords = normalizedMatch.split(/[\s-]+/);

    // Find all unique matching words (case insensitive)
    const matches = new Set();
    matchWords.forEach((rawMatchWord) => {
      const matchWord = normalize(rawMatchWord);
      textWords.forEach((rawTextWord) => {
        const textWord = normalize(rawTextWord);

        if (textWord === matchWord) {
          matches.add(textWord); // Already normalized
        }
      });
    });
    if (matches.size === 0) return text; // No matches, return original text
    // Create a regex pattern without word boundaries (`\b`) to match standalone words properly
    //  const regex = new RegExp(`(${[...matches].join('|')})`, 'gi');

    // Replace matched words with highlighted `<span>` elements
    return text.split(/([\s-–—‐]+)/).map((word, index) =>
      matches.has(word.replace(/[;,-]/g, "").toLowerCase().trim()) ? (
        <span key={index} style={{ backgroundColor: "yellow" }}>
          {word}
        </span>
      ) : (
        word
      )
    );
    //     .reduce((prev, curr) => (prev === null ? [curr] : [...prev, curr]), null);
    // const tokens = text.split(/(\W+)/); // splits on non-word characters while keeping them

    // return tokens
    //   .map((word, index) => {
    //     const normalized = normalize(normalizeDashesAndSpaces(word));
    //     return matches.has(normalized) ? (
    //       <span key={index} style={{ backgroundColor: "yellow" }}>
    //         {word}
    //       </span>
    //     ) : (
    //       word
    //     );
    //   })
    //   .reduce((prev, curr) => (prev === null ? [curr] : [...prev, curr]), null);
  };

  function normalize(text) {
    return text
      .toLowerCase()
      .replace(/[;,]/g, "") // Removes semicolons and commas
      .replace(/\s+/g, " ") // Converts multiple spaces/tabs/newlines to a single space
      .trim(); // Removes leading and trailing spaces
  }

  // const normalizeDashesAndSpaces = (str) => {
  //   return (
  //     str
  //       // Convert all kinds of dashes/hyphens to ASCII hyphen (-)
  //       .replace(/[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g, "-")
  //       // Convert all kinds of spaces (e.g. NBSP, thin space, etc.) to a normal space
  //       .replace(/[\u00A0\u1680\u180E\u2000-\u200A\u202F\u205F\u3000]/g, " ")
  //   );
  // };

  const approveHandler = () => {
    setModal({
      show: true,
      modalType: "approved",
      header: "Approve Manuscript",
      message:
        "Are you sure you want to take approve action for this manuscript?",
      actionName: "Action",
      action: "Approve",
      clientData: clientData,
      curationData: updatedCurationData,
    });
  };
  const author = (
    <div>
      <div className="text-muted">Authors:</div>
      <div className="fw-semibold">{curationData.matched_authorsNames_doi}</div>
    </div>
  );

  const doi = (
    <div>
      <div className="text-muted">DOI:</div>
      <div className="fw-semibold">
        <a
          href={"https://doi.org/" + curationData.match_doi}
          className="text-decoration-none"
          target="_blank"
        >
          {curationData.match_doi}
        </a>
      </div>
    </div>
  );

  const publishedDate = (
    <div>
      <div className="text-muted">Published Date:</div>
      <div className="fw-semibold">{curationData.match_earliest_date}</div>
    </div>
  );

  const titleScore = (
    <div>
      <div className="text-muted">Title Score:</div>
      <div className="fw-semibold">{curationData.tscore}</div>
    </div>
  );

  const authorScore = (
    <div>
      <div className="text-muted">Author Score:</div>
      <div className="fw-semibold">{curationData.ascore}</div>
    </div>
  );

  const tier = (
    <div>
      <div className="text-muted">Tier:</div>
      <div className="fw-semibold">{curationData.passType}</div>
    </div>
  );

  const rejectionDateValidity = (
    <div>
      <div className="text-muted">Date Validity Flag:</div>
      <div className="fw-semibold">{curationData.dateFlag}</div>
    </div>
  );

  const threshold = (
    <div>
      <div className="text-muted">Threshold:</div>
      <div className="fw-semibold">{curationData.threshold}</div>
    </div>
  );

  const llmAuthorScore = (
    <div>
      <div className="text-muted">LLM Author Score:</div>
      <div className="fw-semibold">{curationData.llm_author_score}</div>
    </div>
  );

  const llmTitleScore = (
    <div>
      <div className="text-muted">LLM Title Score:</div>
      <div className="fw-semibold">{curationData.llm_title_score}</div>
    </div>
  );

  const authorStatusFlag = (
    <div>
      <div className="text-muted">Author Status Flag:</div>
      <div className="fw-semibold">{curationData.authorStatusFlag}</div>
    </div>
  );

  const usercomment = (
    <div>
      <div className="text-muted">Comment:</div>
      <div className="fw-semibold">{curationData.comment}</div>
    </div>
  );

  return (
    <div className="m-3">
      <div>
        <div className="text-muted">Accepting Title</div>
        <div className="fw-semibold">
          {highlightAuthorMatches(
            curationData.match_title,
            clientData?.submissionTitle
          )}
        </div>
      </div>
      <div>
        {modal.show ? (
          <div>
            <div className="d-flex mt-2">
              <div className="col">{doi}</div>
              <div className="col">{publishedDate}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{titleScore}</div>
              <div className="col">{authorScore}</div>
              {/* <div className="col">{tier}</div> */}
            </div>
            <div className="col mt-2">
              {/*{author}*/}
              <div>
                <div className="text-muted">Authors:</div>
                <div className="fw-semibold">
                  {highlightAuthorMatches(
                    curationData.matched_authorsNames_doi,
                    clientData?.authorFullName
                  )}
                </div>
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{tier}</div>
              <div className="col">{rejectionDateValidity}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{threshold}</div>
              <div className="col">{authorStatusFlag}</div>
            </div>

            <div className="d-flex mt-2">
              <div className="col">{llmTitleScore}</div>
              <div className="col">{llmAuthorScore}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{usercomment}</div>
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex mt-2">
              <div>
                <div className="text-muted">Authors:</div>
                <div className="fw-semibold">
                  {highlightAuthorMatches(
                    curationData.matched_authorsNames_doi,
                    clientData?.authorFullName +
                      " " +
                      clientData?.coAuthors +
                      " " +
                      clientData?.correspondingAuthor
                  )}
                </div>
              </div>
              <div className="col">{doi}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{publishedDate}</div>
              <div className="col">{titleScore}</div>
              <div className="col">{authorScore}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{tier}</div>
              <div className="col">{rejectionDateValidity}</div>
              <div className="col">{threshold}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col">{llmTitleScore}</div>
              <div className="col">{llmAuthorScore}</div>
              <div className="col">{authorStatusFlag}</div>
            </div>
            <div className="d-flex mt-2">
              <div className="col mt-1 mb-2">
                <label className="text-muted">Comment:</label>
                <div className="d-flex">
                  <textarea
                    className=" border border-1 rounded border-secondary w-100"
                    placeholder="Please add the comment here..."
                    rows="2"
                    value={comment}
                    onChange={(e) => {
                      setcomment(e.target.value);
                    }}
                  ></textarea>
                  <input
                    type="button"
                    className="btn btn-success p-1 m-3"
                    value={"Add comment"}
                    onClick={handleSaveComment}
                    disabled={(manuscriptStatus !== "noAction") | freezeStatus}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {!modal.show && (
        <div>
          <div className="d-inline text-muted" onClick={abstractHandler}>
            Abstract <i className="bi bi-caret-down-fill"> </i>
          </div>
          {isAbstractOpen && (
            <div className="fw-semibold">
              {curationData.matched_abstracte_doi}
            </div>
          )}
        </div>
      )}
      {!modal.show && (
        <div className="text-end mt-1">
          <button
            className="btn btn-primary"
            onClick={approveHandler}
            disabled={(manuscriptStatus !== "noAction") | freezeStatus}
          >
            Approve
          </button>
        </div>
      )}
    </div>
  );
};

export default AcceptingModule;
